import React from 'react';
import { FiAlertCircle } from 'react-icons/fi';
import styles from '../Auth.module.css';

/**
 * AuthInput - Reusable input field with icon and error handling
 */
const AuthInput = ({
  icon: Icon,
  label,
  error,
  className = '',
  id,
  ...inputProps
}) => {
  const inputId = id || `input-${label?.toLowerCase().replace(/\s+/g, '-')}`;
  
  return (
    <div className={styles['au-input-group']}>
      {label && (
        <label 
          htmlFor={inputId}
          className={styles['au-input-group__label']}
        >
          {label}
        </label>
      )}
      
      <div className={styles['au-input-group__wrapper']}>
        {Icon && (
          <span className={styles['au-input-group__icon']}>
            <Icon />
          </span>
        )}
        
        <input
          id={inputId}
          className={`
            ${styles['au-input']} 
            ${!Icon ? styles['au-input--no-icon'] : ''} 
            ${error ? styles['au-input--error'] : ''}
            ${className}
          `.trim()}
          {...inputProps}
        />
      </div>
      
      {error && (
        <div className={styles['au-input-group__error']}>
          <FiAlertCircle size={14} />
          <span>{error}</span>
        </div>
      )}
    </div>
  );
};

export default AuthInput;
